export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtri"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stato"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Negozio"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conto"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Applica"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancella tutto"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona stato"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona negozio"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci numero fattura"])}
}